export const newOnShowMoreClickHandler = component => {
  return () => {
    const prevResults = component.state.result;
    const result = prevResults.results;
    const ids = result.reduce((acc, r) => {
      acc.add(r.id);
      return acc;
    }, new Set());

    component.search(component.props.country, true).then(data => {
      const filteredResults = data.result.results.filter(r => !ids.has(r.id));
      const additionalResults = result.concat(filteredResults);
      component.setState(() => ({
        result: {
          ...prevResults,
          ...data.result,
          results: additionalResults,
        },
      }));
    });
  };
};
